import { PaymentStatus, TagIndicator } from './interface';
import { TagColors } from '@navi/web-ui/lib/primitives/Tag/types';
import { MarkerState } from './utils';

export const VISIT_PLAN = 'VISIT_PLAN';
export const AGENCY = 'AGENCY';
export const AGENT_ID = 'AGENT_ID';
export const RANK = 'addressRank';
export const TEAM_LEAD = 'TEAM_LEAD';
export const DATE = 'DATE';

export const TAGS_INDICATOR_MAP: Record<MarkerState, TagIndicator> = {
  [MarkerState.UNVISITED]: {
    key: 'UNVISITED',
    label: 'Unvisited',
    color: 'var(--greyscale-5)',
    borderColor: 'var(--grayscale-cold-4)',
    fontColor: 'text-black',
    boxShadow: 'none'
  },
  [MarkerState.VISITED]: {
    key: 'VISITED',
    label: 'Visited',
    color: 'var(--greyscale-content-3)',
    borderColor: 'var(--grayscale-cold-4)',
    fontColor: 'text-white',
    boxShadow: 'none'
  },
  [MarkerState.SELECTED]: {
    key: 'SELECTED',
    label: 'Selected',
    color: 'var(--blue-dark)',
    borderColor: 'var(--bg-secondary)',
    fontColor: 'text-white',
    boxShadow: '0px 0px 6.3px 0px rgba(2, 118, 254, 0.80)'
  },
  [MarkerState.IN_VISIT_PLAN]: {
    key: 'IN_VISIT_PLAN',
    label: 'In Visit Plan',
    color: 'var(--navi-color-violet-dark)',
    borderColor: 'var(--bg-primary)',
    fontColor: 'text-white',
    boxShadow: '0px 0px 6.3px 0px var(--violet-base)'
  },
  [MarkerState.PAID]: {
    key: 'PAID',
    label: 'Paid',
    color: 'var(--green-dark)',
    borderColor: 'var(--bg-primary)',
    fontColor: 'text-white',
    boxShadow: 'none'
  },
  [MarkerState.PARTIALLY_PAID_PTP]: {
    key: 'PARTIALLY_PAID_PTP',
    label: 'Partially Paid/PTP',
    color: '#AFE9BF',
    borderColor: 'var(--bg-primary)',
    fontColor: 'text-[var(--greyscale-content-3)]',
    boxShadow: 'none'
  }
};

export const ADDRESS_RANK_OPTIONS = ['1', '2', '3', '4', '5'];
export const DEFAULT_RANK = '1';

export enum ViewType {
  CASE_LIST = 'CASE_LIST',
  VISIT_PLAN = 'VISIT_PLAN'
}

export const paymentStatusMapping: Record<PaymentStatus, { label: string; color: TagColors }> = {
  PAID: { label: 'Paid', color: 'green' },
  PARTIALLY_PAID: { label: 'Partially Paid', color: 'green' },
  UNPAID: { label: 'Unpaid', color: 'red' },
  CLOSED: { label: 'Closed', color: 'green' }
};

export const PROMISE_TO_PAY = 'PROMISE_TO_PAY';

// Distance filtering configuration
export const MAX_CASE_DISTANCE_KM = 20;

// Distance calculation types
export enum DistanceCalculationType {
  HAVERSINE = 'HAVERSINE',
  GRAPHHOPPER = 'GRAPHHOPPER'
}

export enum VISIT_PLAN_SOURCE {
  LONGHORN = 'LONGHORN',
  COSMOS = 'COSMOS'
}
